import api from './api';

const paymentMethodService = {
  // Get all payment methods
  getPaymentMethods: async () => {
    try {
      const response = await api.get('/payment-methods');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to fetch payment methods' };
    }
  },

  // Create a new payment method
  createPaymentMethod: async (paymentMethodData) => {
    try {
      const response = await api.post('/payment-methods', paymentMethodData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to create payment method' };
    }
  },

  // Update a payment method
  updatePaymentMethod: async (id, paymentMethodData) => {
    try {
      const response = await api.put(`/payment-methods/${id}`, paymentMethodData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to update payment method' };
    }
  },

  // Delete a payment method
  deletePaymentMethod: async (id) => {
    try {
      const response = await api.delete(`/payment-methods/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to delete payment method' };
    }
  },

  // Initialize default payment methods
  initializeDefaults: async () => {
    try {
      const response = await api.post('/payment-methods/initialize-defaults');
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: 'Failed to initialize default payment methods' };
    }
  }
};

export default paymentMethodService;
